<ng-template #ratingAndLevelDescription>
  <div>{{ tooltip }}</div>
  <br />
  <div
    [dgxLineClampHtml]="
      'Cred_levelTitle'
        | translate: { level: level, name: getLevelDescription(level) }
    "
    [clampLinesMax]="10"
  ></div>
</ng-template>
<div
  *ngIf="showDonut"
  [ngbTooltip]="
    level && getLevelDescription(level) ? ratingAndLevelDescription : tooltip
  "
  triggers="hover"
  [container]="'body'"
  [disableTooltip]="!showDonut"
  (click)="clickHandler($event)"
  (keydown)="keydownHandler($event)"
  [attr.tabindex]="tabIndex"
  [attr.role]="role"
  [attr.data-dgat]="dgat"
  [attr.aria-label]="ariaLabel"
>
  <dgx-tag-rating-donut
    class="ib"
    size="sm"
    [level]="level"
    [showDefaultPlus]="showDefaultPlus"
    [isOwner]="isOwner"
    [showLock]="showLock"
    [showPending]="inProgress"
  ></dgx-tag-rating-donut>
</div>
